import { z } from "zod";
import {
  SectionSpacingSchema,
  TextAlignSchema
} from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionColumnsItemSchema = z.object({
  title: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  icons: z.array(z.string()).optional().nullable()
});
const FeatureSectionColumnsSchema = z.object({
  id: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  textAlign: TextAlignSchema.optional().nullable(),
  logoImage: z.string().optional().nullable(),
  logoImageAlt: z.string().optional().nullable(),
  boardImage: z.string().optional().nullable(),
  columnsAlign: TextAlignSchema.optional().nullable(),
  columns: FeatureSectionColumnsItemSchema.array().optional().nullable(),
  bgImage: z.string().optional().nullable(),
  button: z.object({
    text: z.string(),
    link: z.string().optional().nullable(),
    download: z.boolean().optional().nullable(),
    target: z.string().optional().nullable(),
    isVisible: z.boolean().optional().nullable(),
    color: z.string().optional().nullable()
  }).optional().nullable()
}).merge(SectionSpacingSchema);
export default FeatureSectionColumnsSchema;
